import { Model } from 'json-api-models';

import { Models, Schemas } from '../models.ts';
import { plainText } from '../utils/format.ts';

export class QuestionRevision extends Model<Schemas['questionRevisions'], Models> {
    /**
     * Whether the question is answered incrementally, checking and explaining
     * each pick as it's made.
     *
     * SBA and MSQ questions with option explanations work this way. MTF
     * answers are scored across every statement, so they're always submitted
     * together, with explanations shown alongside the result.
     */
    get answersIncrementally() {
        return (
            this.responseType !== 'mtf' &&
            !!this.optionExplanations?.some((_, index) => this.hasOptionExplanation(index))
        );
    }

    hasOptionExplanation(index: number) {
        return !!plainText(this.optionExplanations?.[index] || '');
    }

    get displayOptions() {
        const indexes = this.options.map((_, index) => index);
        const order = this.optionOrder;

        const orderedIndexes =
            order &&
            order.length === indexes.length &&
            ![...order].sort((a, b) => a - b).some((index, i) => index !== indexes[i])
                ? order
                : indexes;

        return orderedIndexes.map((index) => ({
            index,
            text: this.options[index],
        }));
    }
}
